import ConsoleApi from "@/consoleapi/consoleApi";
import {AxiosResponse} from "axios";

/**
 *
 */
export default class Initialize extends ConsoleApi {
    /**
     *
     */
    protected readonly resource = '/initialize';

    /**
     *
     */
    public get(): Promise<AxiosResponse> {
        return this.axios.get(this.requestUri + this.resource, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param userName ここでいうところのUserNameは漕ぐニートのやつな
     * @param name
     * @param kana
     * @param phoneNumber
     * @param companyName
     * @param address
     */
    public post(userName: string, name: string, kana: string, phoneNumber: string, companyName: string | null, address: string | null): Promise<AxiosResponse> {
        return this.axios.post(this.requestUri + this.resource, {
            "cognito_user_name": userName,
            "name": name,
            "name_kana": kana,
            "contact_phone_number": phoneNumber,
            "address": address,
            "company_name": companyName
        }, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            },

        });
    }
}